"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectStatusLabel = exports.ProjectStatusLabelDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var lodash_1 = require("lodash");
var use_icons_1 = require("../../hooks/use-icons");
var title_case_1 = require("../../utils/title-case");
var icon_1 = require("../elements/icon");
exports.ProjectStatusLabelDefaultProps = {
  tag: "h4",
  iconSize: 24,
  iconAtEnd: false
};
// -------- Styles ----------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    display: flex;\n    font-weight: 400;\n    align-items: center;\n\n    ", "\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    display: flex;\n    font-weight: 400;\n    align-items: center;\n\n    ", "\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(15), function (props) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", "\n    "], ["\n      color: ", "\n    "])), theme_1.theme.COLOR(props.color));
  })
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    white-space: nowrap;\n    order: 2;\n  "], ["\n    white-space: nowrap;\n    order: 2;\n  "])))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-shrink: 0;\n\n    ", "\n\n    ", "\n  "], ["\n    flex-shrink: 0;\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var atEnd = _a.atEnd,
      size = _a.size;
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      order: 1;\n      margin-right: ", ";\n    "], ["\n      order: 1;\n      margin-right: ", ";\n    "])), (0, lodash_1.isNumber)(size) && size <= 24 ? theme_1.theme.UNIT(2) : theme_1.theme.UNIT(3));
  }, function (_a) {
    var atEnd = _a.atEnd,
      size = _a.size;
    return atEnd && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      order: 3;\n      margin-right: 0;\n      margin-left: ", ";\n    "], ["\n      order: 3;\n      margin-right: 0;\n      margin-left: ", ";\n    "])), (0, lodash_1.isNumber)(size) && size <= 24 ? theme_1.theme.UNIT(2) : theme_1.theme.UNIT(3));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled_components_1.default.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var ProjectStatusLabel = function (props) {
  var className = props.className,
    entity = props.entity,
    tag = props.tag,
    iconSize = props.iconSize,
    iconAtEnd = props.iconAtEnd;
  var icons = (0, use_icons_1.useIcons)();
  var StatusIcon = icons.ProjectStatus[(0, title_case_1.titleCase)(entity.slug)] || icons.ProjectStatus.NotStarted;
  var statusColor = "projectStatus.".concat((0, lodash_1.camelCase)(entity.slug || 'not-started'));
  // const { label } = entity;
  return react_1.default.createElement(My.Container, {
    color: statusColor,
    as: tag,
    className: className
  }, react_1.default.createElement(My.Icon, {
    atEnd: iconAtEnd,
    size: iconSize,
    color: statusColor
  }, react_1.default.createElement(StatusIcon, null)), react_1.default.createElement(My.Label, null, entity.name));
};
exports.ProjectStatusLabel = ProjectStatusLabel;
exports.ProjectStatusLabel.defaultProps = exports.ProjectStatusLabelDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;